module.exports = __webpack_public_path__ + "media/images/emblems/Haerkingen-blason-c3c3ef6caaaf2f761b85fc565bc1c938.png";